import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetAllAccounting {
  message: string,
  success: boolean,
  result: [{
    ID: number,
    QUOTATION_NO: string,
    QUOTATION_VERSION: string,
    VERSION_DATE: Date,
    QUOTATION_START: Date,
    QUOTATION_END: Date,
    CUSTOMER_NAME: string,
    CUSTOMER_DETAIL: string,
    TITLE: string,
    TAX_NO: string,
    ACCOUNTING_NAME: string,
    REMARK: string,
    INCLUDE_VAT: number,
    STATUS: string,
    CREATE_BY: string,
    CREATE_DATE: Date,
    ACCOUNTING_ID: string,
    ACCOUNT_GROUP: string,
    ACOUNT_GROUP_TH: string,
    TOTAL_PRICE: number,
    QUOTATION: string,
    CREATE_USER: string,
    PATAIL_PRICE: number,
  }]
}

interface resGetActiveAccount {
  message: string,
  success: boolean,
  result: [{
    ACCOUNTING_ID: string,
    ACCOUNTING_NAME: string,
    CREATE_DATE: Date,
    ACCOUNT_GROUP: string,
    ACOUNT_GROUP_TH: string
  }]
}

interface resCreateQuotation {
  message: string,
  success: boolean,
  result: {
    QUOTATION_NO: string,
    QUOTATION_VERSION: number,
  }
}

interface resCreateInvoice {
  message: string,
  success: boolean,
  result: {
    INVOICE_NO: string,
  }
}

interface resGetDetailQuotation {
  message: string,
  success: boolean,
  result: [{
    ID: number,
    QUOTATION_NO: string,
    QUOTATION_VERSION: string,
    QUOTATION_START: Date,
    QUOTATION_END: Date,
    CUSTOMER_NAME: string,
    CUSTOMER_DETAIL: string,
    TITLE: string,
    TAX_NO: string,
    ACCOUNTING_NAME: string,
    REMARK: string,
    INCLUDE_VAT: 1,
    STATUS: string,
    CREATE_BY: string,
    CREATE_DATE: Date,
    ACCOUNTING_ID: string,
    quoDetail: [
      {
        ID: number,
        QUOTATION_NO: string,
        QUOTATION_VERSION: string,
        DESCRIPTION: string,
        QTY: number,
        UNIT_PRICE: number,
        TOTAL: number,
        DISCOUNT: number,
        CREATE_DATE: Date,
        UPDATE_DATE: Date,
        ITEM_NUM: number
      },]
  }]
}

interface resGetDetailInvoice {
  message: string,
  success: boolean,
  result: [{
    ID: number,
    QUOTATION_NO: string,
    QUOTATION_VERSION: string,
    QUOTATION_START: Date,
    QUOTATION_END: Date,
    CUSTOMER_NAME: string,
    CUSTOMER_DETAIL: string,
    TITLE: string,
    TAX_NO: string,
    ACCOUNTING_NAME: string,
    REMARK: string,
    INCLUDE_VAT: 1,
    STATUS: string,
    CREATE_BY: string,
    CREATE_DATE: Date,
    ACCOUNTING_ID: string,
    invDetail: [
      {
        ID: number,
        QUOTATION_NO: string,
        QUOTATION_VERSION: string,
        DESCRIPTION: string,
        QTY: number,
        UNIT_PRICE: number,
        TOTAL: number,
        DISCOUNT: number,
        CREATE_DATE: Date,
        UPDATE_DATE: Date,
        ITEM_NUM: number
      },]
  }]
}

interface resGetDetailPartial {
  message: string,
  success: boolean,
  result: {
    Quotation_Sum_Price: number,
    Partiel_Price: number,
    Invoices: [{
      INVOICE_NO: string,
      QUOTATION_NO: string,
      QUOTATION_VERSION: string,
      STATUS: string,
      TOTAL: number,
      CREATE_DATE: Date,
      UPDATE_DATE: Date,
      CREATE_BY: string,
      CANCEL_REMARK: string,
    }],
  }
}

interface resGetDetailReceipt {
  message: string,
  success: boolean,
  result: [{
    RECEIPT_NO: string,
    INVOICE_NO: string,
    CUSTOMER_NAME: string,
    CUSTOMER_DETAIL: string,
    TAX_NO: string,
    STATUS: string,
    CREATE_DATE: Date,
    INCLUDE_VAT: number,
    REMARK: string,
    RECEIPT_TYPE: string,
    ACCOUNTING_ID: string,
    ACCOUNTING_NAME: string,
    CREATE_BY: string,
    TITLE: string,
    DISCOUNT: number,
    TOTAL: number,
    VAT_PRICE: number,
    BEFORE_VAT: number,
    GRAND_TOTAL: number,
    CANCEL_REMARK: string,
    CUSTOMER_TYPE: string,
    reDetail: [{
      ID: number,
      RECEIPT_NO: string,
      DESCRIPTION: string,
      QTY: number,
      UNIT_PRICE: number,
      DISCOUNT: number,
      TOTAL: number,
      CREATE_DATE: Date,
      UPDATE_DATE: Date,
      ITEM_NUM: number
    },]
  }]
}

interface resCreateReceipt {
  message: string,
  success: boolean,
  result: {
    RECEIPT_NO: string,
  }
}

@Injectable({
  providedIn: 'root'
})

export class AccountingService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllAccounting(type, account) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetAllAccounting>(environment.URL + `/quotation/getAllAccounting?ACCOUNT_GROUP=${account}&TYPE=${type}`, { headers: headers });
  }

  getActiveAccount() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetActiveAccount>(environment.URL + `/accounting/getActiveAccount`, { headers: headers });
  }

  // quotation
  getDetailQuotation(id, version) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetDetailQuotation>(environment.URL + `/quotation/getDetailQuotaion?QUOTATION_NO=${id}&QUOTATION_VERSION=${version}`, { headers: headers });
  }

  createQuotation(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateQuotation>(environment.URL + '/quotation/createQuotation', body, { headers: headers });
  }

  updateQuotation(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateQuotation>(environment.URL + '/quotation/updateQuotation', body, { headers: headers });
  }

  cancelQuotation(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateQuotation>(environment.URL + '/quotation/cancelQuotation', body, { headers: headers });
  }

  // invoice
  createInvoice(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateInvoice>(environment.URL + '/invoice/createInvoice', body, { headers: headers });
  }

  updateInvoice(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateInvoice>(environment.URL + '/invoice/updateInvoice', body, { headers: headers });
  }

  getDetailInvoice(id) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetDetailInvoice>(environment.URL + `/invoice/getDetailInvoice?INVOICE_NO=${id}`, { headers: headers });
  }

  getDetailPartial(id, ver) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetDetailPartial>(environment.URL + `/quotation/getDetailPartial?QUOTATION_NO=${id}&QUOTATION_VERSION=${ver}`, { headers: headers });
  }

  cancelInvoice(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateInvoice>(environment.URL + '/invoice/cancelInvoice', body, { headers: headers });
  }

  // receipt
  createCumulativeReceipt(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateReceipt>(environment.URL + '/receipt/createCumulativeReceipt', body, { headers: headers });
  }

  createFullReceipt(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateReceipt>(environment.URL + '/receipt/createReceipt', body, { headers: headers });
  }

  cancelReceipt(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resCreateReceipt>(environment.URL + '/receipt/cancelReceipt', body, { headers: headers });
  }

  getDetailReceipt(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resGetDetailReceipt>(environment.URL + '/receipt/getDetailReceipt', body, { headers: headers });
  }


}
